'use strict';

angular.module('theme').service('CampaignService', function ($q, $http) {

	this.get = function (campaignCode) {
		if (!campaignCode) {
			return $q.reject('campaignCode cannot be null');
		}

		return $http({
			url: '/wp-json/mk/campaigns/' + encodeURI(campaignCode),
			method: 'GET',
		}).then(function (response) {

			if (!response.data) {
				return $q.reject('no campaign with ' + campaignCode + ' found');
			}

			return response.data;
		});
	};

});
